export default "__VITE_PUBLIC_ASSET__b934730c__"